import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Lock, Mic } from "lucide-react";
import { Link } from "react-router-dom";

export default function Interview() {
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState("hse-officer");
  const [qs, setQs] = useState([]);
  const [open, setOpen] = useState({});

  useEffect(() => { api.get("/interview/roles").then(r => setRoles(r.data.roles)); }, []);
  useEffect(() => { api.get("/interview/questions", { params: { role } }).then(r => setQs(r.data.questions)); }, [role]);

  return (
    <div className="space-y-5" data-testid="interview-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Interview Preparation</h1>
          <p className="text-slate-600 dark:text-slate-400 mt-1">Role-based Q&A with short + professional answers and examples.</p>
        </div>
        <Link to="/tools/simulator" data-testid="open-simulator-btn" className="btn-accent !py-2 !px-4 text-sm"><Mic className="h-4 w-4" /> Spoken simulator</Link>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1">
        {roles.map(r => (
          <button key={r.slug} data-testid={`role-${r.slug}`} onClick={()=>setRole(r.slug)}
                  className={`pill whitespace-nowrap ${role === r.slug ? "bg-slate-900 text-white dark:bg-amber-500 dark:text-slate-950" : "bg-slate-100 dark:bg-slate-800"}`}>{r.name}</button>
        ))}
      </div>

      <div className="space-y-3">
        {qs.map(q => (
          <div key={q.iq_id} className={`rounded-2xl border p-4 ${q.locked ? "border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50" : "border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900"}`}>
            <button data-testid={`iq-toggle-${q.iq_id}`} onClick={()=>setOpen(o=>({...o, [q.iq_id]: !o[q.iq_id]}))} className="w-full text-left flex items-start justify-between gap-3">
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-500">{q.category}</div>
                <h3 className="font-semibold">{q.text}</h3>
                <div className="text-sm text-slate-600 dark:text-slate-400 mt-1">{q.short_answer}</div>
              </div>
              {q.locked && <Lock className="h-4 w-4 text-amber-500" />}
            </button>
            {open[q.iq_id] && (
              q.locked ? (
                <Link to="/subscription" className="btn-accent mt-3 inline-flex">Unlock premium answers</Link>
              ) : (
                <div className="mt-3 space-y-3 text-sm">
                  <div><div className="text-xs uppercase tracking-widest text-amber-600">Professional answer</div><p className="mt-1">{q.professional_answer}</p></div>
                  <div><div className="text-xs uppercase tracking-widest text-amber-600">Practical example</div><p className="mt-1">{q.example}</p></div>
                  <div><div className="text-xs uppercase tracking-widest text-amber-600">Key points</div>
                    <ul className="mt-1 flex flex-wrap gap-1">{q.key_points?.map((k,i)=>(<li key={i} className="pill bg-slate-100 dark:bg-slate-800">{k}</li>))}</ul>
                  </div>
                </div>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
